import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["checked", "name", "value", "onChange"],
  _excluded2 = ["input", "meta", "error", "valueProxy", "onChangeProxy", "errorProxy"],
  _excluded3 = ["value"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { allowParamOmit } from '@beef/react';
import { emptyObj, passAsIs } from '@beef/utils';
function withFinalField() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyObj,
    type = _ref.type;
  return function (WrappedInput) {
    var FFInput = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(FFInput, _React$PureComponent);
      var _super = _createSuper(FFInput);
      function FFInput(props) {
        var _this;
        _classCallCheck(this, FFInput);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleFocus", function (v, e) {
          var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            input = _this$props.input;
          input.onFocus(e);
          onFocus === null || onFocus === void 0 ? void 0 : onFocus(v, e);
        });
        _defineProperty(_assertThisInitialized(_this), "handleBlur", function (v, e) {
          var _this$props2 = _this.props,
            onBlur = _this$props2.onBlur,
            input = _this$props2.input;
          input.onBlur(e);
          onBlur === null || onBlur === void 0 ? void 0 : onBlur(v, e);
        });
        var _props$meta = props.meta,
          error = _props$meta.error,
          initial = _props$meta.initial;
        _this.initialError = initial && error;
        return _this;
      }
      _createClass(FFInput, [{
        key: "render",
        value: function render() {
          var _this$props3 = this.props,
            _this$props3$input = _this$props3.input,
            checked = _this$props3$input.checked,
            name = _this$props3$input.name,
            originalValue = _this$props3$input.value,
            onChange = _this$props3$input.onChange,
            domInputProps = _objectWithoutProperties(_this$props3$input, _excluded),
            _this$props3$meta = _this$props3.meta,
            touched = _this$props3$meta.touched,
            dirty = _this$props3$meta.dirty,
            error = _this$props3$meta.error,
            submitError = _this$props3$meta.submitError,
            dirtySinceLastSubmit = _this$props3$meta.dirtySinceLastSubmit,
            submitFailed = _this$props3$meta.submitFailed,
            forcedError = _this$props3.error,
            valueProxy = _this$props3.valueProxy,
            onChangeProxy = _this$props3.onChangeProxy,
            errorProxy = _this$props3.errorProxy,
            inheritedProps = _objectWithoutProperties(_this$props3, _excluded2);
          var value = type === 'checkbox' || type === 'radio' ? checked : originalValue;
          var handleChange = typeof onChangeProxy === 'function' ? function (val, event) {
            return onChange(onChangeProxy(val, event), event);
          } : onChange;
          var val = typeof valueProxy === 'function' ? valueProxy(value) : value;
          var err = typeof errorProxy === 'function' ? errorProxy(error) : error;

          // if (name === 'name') console.log({ ...this.props.meta });
          /**
           * Error should not be shown initially on an empty field
           */
          var shouldShowError = touched && dirty || submitFailed || this.initialError;
          return /*#__PURE__*/React.createElement(WrappedInput, _extends({}, inheritedProps, domInputProps, {
            onBlur: this.handleBlur,
            onChange: handleChange,
            onFocus: this.handleFocus
          }, typeof val !== 'undefined' && val !== null ? {
            value: val
          } : {}, {
            /** There are three sources of errors - manually passed error, validation error and submission error */
            error: shouldShowError && (forcedError || err || !dirtySinceLastSubmit && submitError) || null,
            name: name,
            status: shouldShowError && (forcedError || err || !dirtySinceLastSubmit && submitError) && 'fail' || null,
            "data-t-id": "src-enhancers"
          }));
        }
      }]);
      return FFInput;
    }(React.PureComponent);
    FFInput.propTypes = process.env.NODE_ENV !== "production" ? {
      valueProxy: PropTypes.func /** to override value before passing it to underlying component */,
      onChangeProxy: PropTypes.func /** to override value before passing it back to redux forms */,
      errorProxy: PropTypes.func,
      /** final-form props */
      input: PropTypes.shape({
        name: PropTypes.string,
        // eslint-disable-next-line react/forbid-prop-types
        value: PropTypes.any,
        checked: PropTypes.bool,
        onChange: PropTypes.func,
        onFocus: PropTypes.func,
        onBlur: PropTypes.func
      }),
      meta: PropTypes.shape({
        touched: PropTypes.bool,
        dirty: PropTypes.bool,
        submitFailed: PropTypes.bool,
        // eslint-disable-next-line react/forbid-prop-types
        initial: PropTypes.any,
        error: PropTypes.string,
        submitError: PropTypes.string,
        dirtySinceLastSubmit: PropTypes.bool
      }),
      // inheritedProps
      type: PropTypes.string,
      error: PropTypes.string
    } : {};

    /**
     * Override component name by prepending `FF~`
     * to make it look nice, for example: `FFTextInput`
     */
    if (process.env.NODE_ENV !== 'production') {
      var WrappedComponentName = WrappedInput.displayName || WrappedInput.name || 'Input';
      FFInput.displayName = "FF".concat(WrappedComponentName);
    }
    var FFInputField = function FFInputField(_ref2) {
      var value = _ref2.value,
        props = _objectWithoutProperties(_ref2, _excluded3);
      return /*#__PURE__*/React.createElement(Field, _extends({
        allowNull: true,
        component: FFInput,
        format: passAsIs,
        parse: passAsIs,
        type: type
      }, _defineProperty({}, type === 'checkbox' ? 'checked' : 'value', value), props));
    };

    /**
     * FFInputField has same props as Wrapped component
     */
    FFInputField.propTypes = process.env.NODE_ENV !== "production" ? {
      /** prop used for internal representation of checkbox */
      // eslint-disable-next-line react/forbid-prop-types
      value: PropTypes.any,
      name: PropTypes.string.isRequired
      /** inherited props */
    } : {};
    return FFInputField;
  };
}
export default allowParamOmit(withFinalField);